// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mClubInvitationModalWidth{max-width:26%}`, "",{"version":3,"sources":["webpack://./src/views/GenericView/StudentView/Messages/MessagesInbox.scss"],"names":[],"mappings":"AAAA,2BACE,aAAA","sourcesContent":[".mClubInvitationModalWidth {\n  max-width: 26%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
